import React from 'react';
import { Helmet } from 'react-helmet';
import { StyleSheet } from 'aphrodite';

import { AppContainer } from '../AppContainer';

export default () => (<div className={newCss(styles.content)}>
  <Helmet>
    <title>Ourisman Travel - Ping Pong</title>
    <link
      href='https://fonts.googleapis.com/css?family=Noto+Sans:400,700&amp;subset=cyrillic,cyrillic-ext'
      rel='stylesheet'
      type='text/css'
    />
    <link rel='stylesheet' href='//cdn.quilljs.com/1.2.6/quill.snow.css' />
  </Helmet>
  <AppContainer />
</div>);

const globalSelectorHandler = (selector, _, generateSubtreeStyles) => {
  if (selector[0] !== '*') {
    return null;
  }

  return generateSubtreeStyles(selector.slice(1));
};
const globalExtension = { selectorHandler: globalSelectorHandler };
const { StyleSheet: newStyleSheet, css: newCss } = StyleSheet.extend([globalExtension]);

const styles = newStyleSheet.create({
  content: {
    fontFamily: 'Noto Sans,sans-serif',
    '*a': {
      ':hover': {
        color: 'inherit',
        fontWeight: 'inherit',
      },
      textDecoration: 'none',
    },
  },
});



// WEBPACK FOOTER //
// /src/components/App/index.js